import {
  AirCfarActionsV2,
  AirChfarActions,
  AirChfarExerciseDiscountActions,
  AirDisruptionActionsV1,
  AirPFExerciseActions,
  AirPriceDropActions,
  BaggageActions,
  CartActions,
  CfarActions,
  ContactInformationActions,
  FlightActions,
  FlightPassengerActionsV2,
  PassportActions,
  ResumeFlightActions,
  ReviewActions,
  SeatActions,
  VipSupportActions,
} from "@hopper-b2b/checkout";

import { NubankPaymentActions } from "../../../checkout/states/payments";
import { commonActions } from "./common";

export const Actions = {
  ...AirChfarActions,
  ...AirChfarExerciseDiscountActions,
  ...AirDisruptionActionsV1,
  ...AirPFExerciseActions,
  ...AirPriceDropActions,
  ...CartActions,
  ...CfarActions,
  ...commonActions,
  ...ContactInformationActions,
  ...FlightActions,
  ...FlightPassengerActionsV2,
  ...NubankPaymentActions,
  ...PassportActions,
  ...ResumeFlightActions,
  ...ReviewActions,
  ...SeatActions,
  ...VipSupportActions,
  ...BaggageActions,
  ...AirCfarActionsV2,
};

type IActionTypes = {
  [K in keyof typeof Actions]: K;
};

export const ActionTypes: IActionTypes = Object.keys(Actions).reduce(
  (prev, cur) => ({ ...prev, [cur]: cur }),
  {} as IActionTypes
);
